
/*
 🌐 Shopify UTM Tracker — Final Optimized v4
 ✅ Supports fbclid/gclid/ttclid/_gl
 ✅ Works on AJAX carts, drawer carts, and Online Store 2.0 themes
 ✅ Refreshes cookies for Safari ITP (keeps them alive >7d)
 ✅ Syncs only when values change
 ✅ No AddToCart bind — fully non-blocking
*/

(function(){
  /*************** Config ***************/
  const COOKIE_DAYS = 90;
  const UTM_KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
  const AD_KEYS  = ['fbclid','gclid','ttclid','_gl'];
  const ALL_KEYS = [...UTM_KEYS, ...AD_KEYS];
  const CART_UPDATE_URL = '/cart/update.js';
  let merged = {};

  /*************** Helper Functions ***************/
  const getParam = n => { try { return new URLSearchParams(location.search).get(n); } catch(e){ return null; } };
  const getCookie = n => { const m = document.cookie.match(new RegExp('(?:^|; )'+n+'=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; };
  const setCookie = (n,v,d) => {
    const t = new Date(); t.setTime(t.getTime()+d*864e5);
    document.cookie = `${n}=${encodeURIComponent(v)};path=/;expires=${t.toUTCString()};SameSite=Lax`;
  };

  /*************** Step 1️⃣: Capture from URL ***************/
  const captured = {};
  ALL_KEYS.forEach(k => {
    const v = getParam(k);
    if (v) captured[k] = v;
  });
   // --- Blocklist of internal sources (menu clicks etc.) ---
  var internalSources = ['nav','menu','homepage','home','internal','footer','header','collection'];
  var src = (captured.utm_source||'').toLowerCase();
 

  const hasCore = captured.utm_source && captured.utm_medium && captured.utm_campaign;
  const isInternal = internalSources.includes(src);

  if (isInternal) {
    console.log('[UTM Tracker] Ignored internal source:', src);
    return; // dừng hoàn toàn — không set cookie
  }

  if (!hasCore) {
    console.log('[UTM Tracker] Skipped — missing core UTM fields');
    return;
  }
 
  /*************** Step 2️⃣: Save to storage ***************/
  Object.entries(captured).forEach(([k,v])=>{
    setCookie(k,v,COOKIE_DAYS);
    try { localStorage.setItem(k,v); } catch(e){}
  });

  /*************** Step 3️⃣: Merge stored data ***************/
  ALL_KEYS.forEach(k=>{
    const val = localStorage.getItem(k) || getCookie(k);
    if (val) merged[k] = val;
  });

  // Fallback: detect from Shopify _orig_referrer
  const origRef = getCookie('_orig_referrer');
  if (origRef && !merged.utm_source){
    merged.utm_source = /facebook/i.test(origRef) ? 'facebook' :
                        /google/i.test(origRef)   ? 'google' :
                        /tiktok/i.test(origRef)   ? 'tiktok' : 'referral';
  }

  if (!Object.keys(merged).length) return;

  /*************** Step 4️⃣: Avoid redundant updates ***************/
  let lastSync = null;
  const sameData = (a,b) => JSON.stringify(a) === JSON.stringify(b);

  async function updateCartAttributes(force=false){
    if(!force && sameData(merged,lastSync)) return;
    lastSync = {...merged};
    try {
      await fetch(CART_UPDATE_URL, {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({attributes:merged})
      });
      console.log('[UTM Tracker] ✅ Synced', merged);
    } catch(e){ console.warn('[UTM Tracker] ⚠️ Sync failed', e); }
  }

  /*************** Step 5️⃣: Smart event-based sync ***************/
  // Initial sync (after cart.js exists)
  fetch('/cart.js').then(updateCartAttributes).catch(()=>{});

  // Sync before checkout
  function bindCheckoutSync(){
    const form=document.querySelector('form[action="/checkout"],form[action^="/checkouts"]');
    if(!form) return;
    form.addEventListener('submit', ev=>{
      ev.preventDefault();
      updateCartAttributes(true).finally(()=>form.submit());
    });
  }
  document.readyState==='loading'
    ? document.addEventListener('DOMContentLoaded',bindCheckoutSync)
    : bindCheckoutSync();

  // Re-sync when AJAX cart updates
  ['cart:updated','cart:change','cart:refresh'].forEach(evt=>{
    document.addEventListener(evt,()=>updateCartAttributes(true));
  });

  // Auto refresh cookie to survive Safari ITP
  ALL_KEYS.forEach(k=>{
    const v=getCookie(k); if(v) setCookie(k,v,COOKIE_DAYS);
  });

})();
